import React from "react";
import { Container, Stack, Heading, Card } from "@chakra-ui/react";

import TaskFormContainer from "../containers/TaskFormContainer";
import TasksOldContainer from "../containers/TasksOldContainer";
import TasksContainer from "../containers/TasksContainer";
import { Header } from "../components/Header";

function DashboardPage({ user }) {
  return (
    <Container width={"full"} maxWidth={"none"} minHeight={"80vh"} p={{ base: "10px", md: "20px" }}>
      <Container height={"100%"} width={"full"} maxWidth={"unset"} px={{ base: 2, md: 4 }}>
        <Stack w={{ base: "full", md: "min-content" }} py={"15px"} borderRadius={"5px"} spacing={0}>
          <Heading as={"h1"} color={"#1a13a8"} fontSize={{ base: "xl", md: "2xl" }}>
            Dashboard
          </Heading>
          <Header fontSize={{ base: "sm", md: "md" }}>{user.job_name}</Header>
        </Stack>
        <Stack direction={"column"} justifyContent={"center"} alignItems={"center"} width={"full"} spacing={4}>
          <Card
            direction={"column"}
            width={{ base: "full" }}
            height={"100%"}
            borderRadius={"5px"}
            display={"flex"}
            py={{ base: 3, md: 6 }}
            px={{ base: 2, md: 4 }}
            gap={4}
            backgroundColor={"transparent"}
            boxShadow={"none"}
          >
            <TasksContainer user={user} />
            <TaskFormContainer user={user} />
            <TasksOldContainer user={user} />
          </Card>
        </Stack>
      </Container>
    </Container>
  );
}

export default DashboardPage;
